(function () {
    'use strict';

    angular.module('app.vendors')
        .run(appRun);

    appRun.$inject = ['routerHelper'];

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'vendors',
                config: {
                    url: '/vendors',
                    title: 'Bayiler',
                    abstract: true,
                    templateUrl: 'app/vendors/vendors.html'
                }
            },
            {
                state: 'vendors.list',
                config: {
                    templateUrl: 'app/vendors/vendors.list.html',
                    controller: 'VendorsListController',
                    controllerAs: 'vm',
                    url: '/list',
                    title: 'Bayi Listesi',
                    settings: {
                        nav: 33,
                        name: 'vendors.list',
                        topName: 'sales',
                        content: 'Bayi Listesi',
                        resource: 'menu.vendors.list'
                    }
                }
            },
            {
                state: 'vendors.add',
                config: {
                    templateUrl: 'app/vendors/vendors.add.html',
                    controller: 'VendorsAddController',
                    controllerAs: 'vm',
                    url: '/add',
                    title: 'Bayi Ekle',
                    settings: {
                        topName: 'vendors.list',
                        topName: 'sales',
                        resource: 'menu.vendors.add'
                    }
                }
            },
            {
                state: 'vendors.edit',
                config: {
                    templateUrl: 'app/vendors/vendors.edit.html',
                    controller: 'VendorsEditController',
                    controllerAs: 'vm',
                    url: '/edit/:VendorId',
                    title: 'Bayi Düzenle',
                    settings: {
                        topName: 'vendors.list',
                        topName: 'sales',
                        resource: 'menu.vendors.edit'
                    }
                }
            },
            {
                state: 'vendors.detail',
                config: {
                    templateUrl: 'app/vendors/vendors.detail.html',
                    controller: 'VendorsDetailController',
                    controllerAs: 'vm',
                    url: '/detail/:VendorId',
                    title: 'Bayi Detay',
                    settings: {
                        topName: 'vendors.list',
                        topName: 'sales',
                        resource: 'menu.vendors.detail'
                    }
                }
            }
        ];
    }
})();